import { useQuery } from 'react-query';
import TranslatorHoliday from '../../../models/TranslatorHoliday';

function useHolidaysByTranslatorId(translatorId?: string) {
    return useQuery<TranslatorHoliday[]>(['translator-holidays', '?userId=', translatorId], { enabled: !!translatorId });
}

export default useHolidaysByTranslatorId;
